import { trailSectionSlidesSizes } from "pages/[tenant]/browse/utils/trailSectionSlidesSizes";

import { LoadingSkeleton } from "shared/components/molecules/LoadingSkeleton";
import useWindowSize from "shared/utils/hooks/useWindowSize";

import { GroupHighlightSlidesLoadingSkeletonContainer } from "./styles";

interface IGroupHighlightSlidesLoadingSkeletonProps {
  contentLength: number;
  orientation: "vertical" | "horizontal";
}

export const GroupHighlightSlidesLoadingSkeleton = ({
  contentLength,
  orientation,
}: IGroupHighlightSlidesLoadingSkeletonProps) => {
  const { width } = useWindowSize();

  const screenWidth = window?.innerWidth ?? width;

  const sizesMap = {
    horizontal: {
      width:
        screenWidth <= 1366
          ? screenWidth <= 500
            ? trailSectionSlidesSizes.horizontal.width[500]
            : trailSectionSlidesSizes.horizontal.width[1366]
          : trailSectionSlidesSizes.horizontal.width.default,
      height:
        screenWidth <= 1366
          ? screenWidth <= 500
            ? trailSectionSlidesSizes.horizontal.height[500]
            : trailSectionSlidesSizes.horizontal.height[1366]
          : trailSectionSlidesSizes.horizontal.height.default,
    },
    vertical: {
      width:
        screenWidth <= 1366
          ? screenWidth <= 500
            ? trailSectionSlidesSizes.vertical.width[500]
            : trailSectionSlidesSizes.vertical.width[1366]
          : trailSectionSlidesSizes.vertical.width.default,
      height:
        screenWidth <= 1366
          ? screenWidth <= 500
            ? trailSectionSlidesSizes.vertical.height[500]
            : trailSectionSlidesSizes.vertical.height[1366]
          : trailSectionSlidesSizes.vertical.height.default,
    },
  };

  return (
    <GroupHighlightSlidesLoadingSkeletonContainer>
      <ul>
        {Array.from({ length: contentLength }, (_, i) => i + 1)?.map((item) => (
          <li key={item}>
            {orientation === "horizontal" ? (
              <LoadingSkeleton.Square
                width={`${sizesMap.horizontal.width}px`}
                height={`${sizesMap.horizontal.height}px`}
              />
            ) : (
              <LoadingSkeleton.Square
                width={`${sizesMap.vertical.width}px`}
                height={`${sizesMap.vertical.height}px`}
              />
            )}
          </li>
        ))}
      </ul>
    </GroupHighlightSlidesLoadingSkeletonContainer>
  );
};
